<template>
  <div>
    <el-dialog
      center
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="90%"
      :before-close="handleClose"
      @open="GetRequestTasksData"
    >
      <el-row gutter="20" type="flex" justify="space-between" class="row-bg">
        <el-col :span="4" class="text-right">
          <h3>
            Total de Horas cerradas: <strong>{{ TotalHoiurs }} h.</strong>
          </h3>
        </el-col>
        <el-col :span="4" class="text-right">
          <h3>
            Total de Horas del mes: <strong>{{ TotalHoursInMonth }} h.</strong>
          </h3>
        </el-col>
        <el-col :span="4" class="text-right">
          <h3>
            Productividad del mes:
            <strong :class="ClassObject"
              >{{ TotalProductividadOfMonth }} %</strong
            >
          </h3>
        </el-col>
      </el-row>
      <rabbey-table-3
        :border="true"
        :stripe="true"
        :actions="TaskActions"
        @rtable-push-action="handlePushAction"
        :loading="loadingData"
        :data="FilteredTasks"
        :columns="TaskColumns"
        :rowClassName="ClassActive"
        show-summary
        sum-text="Tiempo Total"
        :summary-method="getSummaries"
        page_Size="500"
        :pageSizes="[500, 1000]"
      />
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">Cerrar</el-button>
        <!-- <el-button type="primary" @click="dialogVisible = false">Confirmar</el-button> -->
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { TasksAndRequestColumns } from "@/columns/ProductiveHoursReportByMonths/ProductiveHoursReportByMonths";
import { TasksAndRequestsActions } from "../../../columns/ProductiveHoursReportByMonths/ProductiveHoursReportByMonths";

export default {
  name: "ProductivityByMonthsTasksAndRequestsList",
  props: {
    dialogVisibleProp: {
      type: Boolean,
      required: true
    },
    rowData: {
      type: Object,
      required: true,
      default: () => ({})
    },
    ColumnData: {
      type: Object,
      required: true,
      default: () => ({})
    },
    filters: {
      type: Object,
      required: true,
      default: () => ({})
    }
  },
  data() {
    return {
      MonthsInSpanish: {
        January: "Enero",
        February: "Febrero",
        March: "Marzo",
        April: "Abril",
        May: "Mayo",
        June: "Junio",
        July: "Julio",
        August: "Agosto",
        September: "Septiembre",
        October: "Octubre",
        November: "Noviembre",
        December: "Diciembre"
      },
      MonthsInNumbers: {
        January: 1,
        February: 2,
        March: 3,
        April: 4,
        May: 5,
        June: 6,
        July: 7,
        August: 8,
        September: 9,
        October: 10,
        November: 11,
        December: 12
      },

      TaskActions: TasksAndRequestsActions,
      loadingData: false,
      TaskColumns: TasksAndRequestColumns(this),
      TaskData: []
    };
  },
  computed: {
    dialogVisible() {
      return this.dialogVisibleProp;
    },
    dialogTitle() {
      let title = "";
      switch (this.filters.Type) {
        case "SI": {
          title = "Solicitudes Internas";
          break;
        }
        case "SE": {
          title = "Solicitudes Externas";
          break;
        }
        case "TE": {
          title = "Tareas Estratégicas";
          break;
        }
        case "TO": {
          title = "Tareas Operacionales";
          break;
        }
        default: {
          title = "Solicitudes y Tareas";
          break;
        }
      }
      return `${title} del mes de ${
        this.MonthsInSpanish[this.ColumnData.property]
      }`;
    },
    FilteredTasks() {
      return this.TaskData;
    },
    TotalHoiurs() {
      let total = 0;
      total = this.TaskData.reduce((acc, obj) => acc + obj.TimeOntask, 0);
      return total.toFixed(2);
    },
    TotalHoursInMonth() {
      return this.getTotalWorkHours(
        this.filters.Year,
        this.MonthsInNumbers[this.ColumnData.property]
      );
    },
    TotalProductividadOfMonth() {
      const totalHours = this.getTotalWorkHours(
        this.filters.Year,
        this.MonthsInNumbers[this.ColumnData.property]
      );
      const productivity = (this.TotalHoiurs / totalHours) * 100;
      return productivity.toFixed(2);
    },
    ClassObject() {
      let isred = false;
      let isyellow = false;
      let isgreen = false;

      if (this.TotalProductividadOfMonth < 80) {
        isred = true;
        isyellow = false;
        isgreen = false;
      } else if (
        this.TotalProductividadOfMonth >= 80 &&
        this.TotalProductividadOfMonth < 90
      ) {
        isyellow = true;
        isred = false;
        isgreen = false;
      } else if (this.TotalProductividadOfMonth >= 90) {
        isgreen = true;
        isred = false;
        isyellow = false;
      } else {
        isred = false;
        isyellow = false;
        isgreen = false;
      }

      let classOject = {
        red: isred,
        yellow: isyellow,
        green: isgreen
      };

      return classOject;
    }
  },
  mounted() {
    this.GetRequestTasksData();
  },

  methods: {
    handleClose() {
      this.dialogVisible = false;
      this.$emit("CloseTaskListDialog", false);
    },
    async GetRequestTasksData() {
      this.loadingData = true;

      await this.$http
        .get(
          "/api/ReporteGestion/Get_Detailed_List_Of_Productive_Hours_Report_By_Month",
          {
            params: {
              ResponsableID: this.rowData.ResponsableID,
              DirecctionID: this.filters.Direction,
              DeparmentId: this.filters.Deparment,
              Year: this.filters.Year,
              Month: this.MonthsInNumbers[this.ColumnData.property],
              WeekOnMothSelected: this.filters.Week,
              Type: this.filters.Type
            }
          }
        )
        .then((response) => {
          this.TaskData = response.data;
          this.loadingData = false;
        })
        .catch(() => {
          this.loadingData = false;
          this.$message.error("Error al cargar los datos de las tareas.");
        })
        .finally(() => {
          this.loadingData = false;
        });
    },
    handlePushAction() {},
    getSummaries(param) {
      const columnsToSum = [
        "TimeOntask"
        // "Monday",
        // "Tuesday",
        // "Wednesday",
        // "Thursday",
        // "Friday",
        // "Saturday",
      ];
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 1) {
          sums[index] = "Tiempo Total";
          return;
        }

        const values = data.map((item) => Number(item[column.property]));

        if (
          !values.every((value) => isNaN(value)) &&
          columnsToSum.includes(column.property)
        ) {
          this.TotalHoiurs = sums[index] =
            values
              .reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return prev + curr;
                } else {
                  return prev;
                }
              }, 0)
              .toFixed(2) + " h.";
        } else {
          sums[index] = "";
        }
      });

      return sums;
    },
    ClassActive() {
      return "active-class";
    },
    getWorkHoursDetailed(year, month) {
      let total = 0;
      let breakdown = [];

      const daysInMonth = new Date(year, month + 1, 0).getDate();

      for (let day = 1; day <= daysInMonth; day++) {
        const date = new Date(year, month, day);
        const dow = date.getDay();

        let hours = dow === 0 ? 0 : dow === 6 ? 4 : 8;

        total += hours;

        breakdown.push({
          date: date.toISOString().split("T")[0],
          day: dow,
          hours
        });
      }

      return { total, breakdown };
    },
    getTotalWorkHours(year, month) {
      let totalHours = 0;

      // month in JS is 0-based (0 = January, 11 = December)
      const daysInMonth = new Date(year, month + 1, 0).getDate();

      for (let day = 1; day <= daysInMonth; day++) {
        const currentDate = new Date(year, month, day);
        const dayOfWeek = currentDate.getDay();
        // 0 = Sunday, 6 = Saturday

        if (dayOfWeek === 0) {
          // Sunday → 0 hours
          totalHours += 0;
        } else if (dayOfWeek === 6) {
          // Saturday → 4 hours
          totalHours += 4;
        } else {
          // Monday - Friday → 8 hours
          totalHours += 8;
        }
      }

      return totalHours;
    }
  }
};
</script>

<style lang="css" scoped>
.red {
  color: red;
}
.yellow {
  color: orange;
}
.green {
  color: green;
}
</style>
